import { ref } from 'vue';
const timeZone = ref('UTC');

export function useTimeZoneStorage() {
  return {
    timeZone,
  };
}
